module.exports = __webpack_public_path__ + "img/1536536963.4efa2b3e.jpg";